import { ReactNode } from 'react';

import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { ButtonBase, ButtonBaseProps, Typography, TypographyProps } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { PrivacyContextAwareMoneyValue } from '../../common';

export const StyledPortfolioCard = styled(ButtonBase)`
  &.portfolio-card {
    align-items: flex-start;
    background-color: ${({ theme }) => theme.palette.neutrals.white};
    border-radius: ${({ theme }) => theme.spacing(0.5)};
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing(3)};
    justify-content: flex-start;

    &:hover .arrow-icon {
      opacity: 1;
    }
  }

  .title {
    position: relative;
    margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  }

  .arrow-icon {
    opacity: 0;
    transition: opacity 150ms;
    font-size: 1em;
    margin-left: ${({ theme }) => theme.spacing(0.5)};
    position: absolute;
  }

  .sub-text {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;

export interface PortfolioCardProps extends Omit<ButtonBaseProps, 'disabled' | 'title'> {
  subText?: ReactNode;
  title: ReactNode;
  titleTypography?: TypographyProps;
  value?: number;
  subtextTypography?: TypographyProps;
}

export const PortfolioCard = ({
  className,
  onClick,
  subText,
  title,
  titleTypography,
  value,
  subtextTypography,
  ...rest
}: PortfolioCardProps) => {
  return (
    <StyledPortfolioCard
      {...rest}
      className={clsx('portfolio-card', className)}
      disabled={onClick == null}
      onClick={onClick}
    >
      <Typography className="title" variant="h5.medium" lineHeight={1} {...titleTypography}>
        {title}
        {onClick && <ArrowForwardIos className="arrow-icon" />}
      </Typography>
      <Typography variant="h4.semibold">
        {value != null ? <PrivacyContextAwareMoneyValue length={5} value={value} /> : '-'}
      </Typography>
      {subText && (
        <Typography
          variant="body2.medium"
          className="sub-text"
          display="flex"
          alignItems="center"
          textTransform="uppercase"
          {...subtextTypography}
        >
          {subText}
        </Typography>
      )}
    </StyledPortfolioCard>
  );
};
